/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import 'moment/locale/pt';

import moment from 'moment'
import { Box, Button, Tab, Tabs, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { DatePicker } from '@mui/x-date-pickers';
import styled from 'styled-components';
import { enqueueSnackbar } from 'notistack';

export default function filterModal({ open, onClose, setFilterValues, setFilter }) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [value, setValue] = useState(0);

  const formatDate = (date) => {
    return moment.utc(new Date(date)).format('DD/MM/YYYY')
  }

  const handleReturnInfos = () => {
    if (!startDate || !endDate) {
      enqueueSnackbar('As duas datas precisam ser preenchidas', { variant: 'info' });
      
      return
    }
    moment.locale('en')

    if (value === 0) {
      setFilterValues(`&date=final&dateStart=${formatDate(startDate)}&dateEnd=${formatDate(endDate)}`)
    } else {
      setFilterValues(`&date=active&dateStart=${formatDate(startDate)}&dateEnd=${formatDate(endDate)}`)
    }

    setFilter(true)
    onClose()
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const Label = styled(Typography)(({ theme }) => ({
    '&': {
      fontSize: '16px',
      marginBottom: '10px'
    },
  }))

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Filtros
        </Typography>
      </Box>

      <Box sx={{
        margin: '16px',
        width: 400,
        height: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
      }}>
        <Box sx={{
          width: '100%'
        }}>
          <Box sx={{
            borderBottom: 1,
            borderColor: 'divider'
          }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Por data final" {...a11yProps(0)} />
              <Tab label="Por data de ativação" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Box>
              <Label>Entre as datas</Label>
              <DatePicker
                sx={{margin: '10px 0'}}
                label="Data inicial"
                value={startDate}
                format="DD/MM/YYYY"
                onChange={(newValue) => setStartDate(newValue)}
              />
              <DatePicker
                sx={{margin: '10px 0'}}
                label="Data final"
                value={endDate}
                format="DD/MM/YYYY"
                onChange={(newValue) => setEndDate(newValue)}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box>
              <Label>Entre as datas</Label>
              <DatePicker
                sx={{margin: '10px 0'}}
                label="Data inicial"
                value={startDate}
                format="DD/MM/YYYY"
                onChange={(newValue) => setStartDate(newValue)}
              />
              <DatePicker
                sx={{margin: '10px 0'}}
                label="Data final"
                value={endDate}
                format="DD/MM/YYYY"
                onChange={(newValue) => setEndDate(newValue)}
              />
            </Box>
          </TabPanel>
        </Box>
      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button variant="contained" color={'success'} onClick={() => handleReturnInfos()}>
          <Typography color={'#fff'}>
            Filtrar
          </Typography>
        </Button>
        <Button variant="contained" onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
